import React from 'react'
import propTypes from 'prop-types'
import Img from 'gatsby-image'
import { useIntl } from 'gatsby-plugin-intl'
import { replaceBucketUrl } from '../utils/cms'
import { getARImage } from '../utils/resolveImageUrlForDeviceAndLocale'

// Render inline SVG with fallback non-svg images
export default function Image({
  svg,
  fluid,
  fixed,
  file,
  title,
  alt,
  className,
}) {
  const { locale } = useIntl()

  if (file?.contentType === 'image/svg+xml' && svg?.content) {
    // Inlined SVGs
    return (
      <div
        dangerouslySetInnerHTML={{ __html: svg.content }}
        className={className}
        title={title || alt}
      />
    )
  }
  if (fluid || fixed) {
    return (
      <Img
        fluid={fluid}
        fixed={fixed}
        alt={title || alt}
        className={className}
      />
    )
  }
  if (file?.url) {
    const url = replaceBucketUrl(file.url)
    const localizedUrl = locale === 'ar' ? getARImage(url) : url
    if (file.url.endsWith('.svg'))
      return (
        <object
          type="image/svg+xml"
          data={localizedUrl}
          className={className}
          title={title || alt}
        >
          <object
            type="image/svg+xml"
            data={url}
            className={className}
            title={title || alt}
          >
            {title || alt}
          </object>
        </object>
      )
    return (
      <object
        type="image/png"
        data={localizedUrl}
        className={className}
        title={title || alt}
      >
        <img src={url} alt={title || alt} className={className} />
      </object>
    )
  }
  return <></>
}

Image.propTypes = {
  svgContent: propTypes.string,
  fluid: propTypes.object,
  fixed: propTypes.object,
  file: propTypes.object.isRequired,
}
